import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { saveAs } from "file-saver";
import { CorporateService } from "../corporate.service";
import { CorporateCancelTripComponent } from '../corporate-cancel-trip/corporate-cancel-trip.component'
import { CorporateLrUpdateComponent } from '../corporate-lr-update/corporate-lr-update.component';

@Component({
  selector: "app-corporate-trips-details",
  templateUrl: "./corporate-trips-details.component.html",
  styleUrls: ["./corporate-trips-details.component.css"],
})
export class CorporateTripsDetailsComponent implements OnInit {
  token: any;
  tripData: any;
  trip_history: any = [];
  selectedCategory: any;
  matDialogRefCancelTrip: any;
  tripNumber: any = -1;
  startPage: any = 1;
  tripType: any = "-1";
  isGeneratingELR: boolean = false;
  downloadingLRIndex: number | null = null;

  constructor(
    private services: CorporateService,
    private matdialogref: MatDialogRef<CorporateTripsDetailsComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.tripData = data;
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("corporate_token");
    this.trip_history = this.getLatestEntries(
      this.tripData?.trip_history
    ).filter(
      (history) =>
        history?.is_verified !== 0
    );
    this.selectedCategory =
      this.tripData.workorderInfo[0]?.pay_as_load_quantity ===
        "unloaded_quantity"
        ? (this.tripData.workOrderOtherDetails?.unloading_point || this.tripData.workOrderOtherDetails?.loading_point || 0)
        : (this.tripData.workOrderOtherDetails?.loading_point || 0);
  }

  generateELR(tripData: any) {
    this.isGeneratingELR = true;
    const tripId = tripData?._id;
    this.services.generateELR(tripId, this.token).subscribe(
      (response: any) => {
        console.log('eLR generated:', response.body);
        this.refreshTripELR(tripData._id);
      },
      (error: any) => {
        console.error('LR generation failed', error);
        this.isGeneratingELR = false;
      }
    );
  }

  onEdit(items: any, index: number) {
    const dialogRef = this.dialog.open(CorporateLrUpdateComponent, {
      width: '100%',
      maxHeight: '80vh',
      disableClose: true,
      data: {
        items,
        index
      }
    });
    dialogRef.afterClosed().subscribe((updated: boolean) => {
      if (updated) {
        this.refreshTripELR(items._id);
      }
    });
  }

  DownloadLR(item: any, i: number) {
    if (this.downloadingLRIndex === i) {
      return; // prevent duplicate click
    }
    this.downloadingLRIndex = i;
    const trip_no = item?.trip_id;
    const elr_no = item.elr_details[i].elr_no;
    const trip_id = item?._id;
    const elr_id = item.elr_details[i]._id;
    this.services.downloadELR(this.token, trip_id, elr_id).subscribe(
      (res: any) => {
        const blob = res.body;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `eLR_${trip_no}_${elr_no}.pdf`;
        a.click();
        URL.revokeObjectURL(url);
        this.downloadingLRIndex = null; // stop loader
      },
      (err) => {
        console.error("ELR download error:", err);
        this.downloadingLRIndex = null; // stop loader on error
      }
    );
  }

  refreshTripELR(tripId: string) {
    this.services
      .getTripList(this.token, this.startPage, this.tripType, this.tripNumber)
      .subscribe((res: any) => {
        const updatedTrip = res.body.data.find(
          (t: any) => t._id === tripId
        );

        if (updatedTrip) {
          this.tripData.elr_details = updatedTrip.elr_details;
        }
        this.isGeneratingELR = false;
      });
  }

  getTotalPrice(): number {
    const pricePerTon =
      Number(this.tripData.workorderInfo[0]?.price_per_ton) || 0;
    if (
      this.tripData.workorderInfo[0]?.pay_as_load_quantity ===
      "unloaded_quantity"
    ) {
      const unloadingPoint = Number(this.tripData.workOrderOtherDetails?.unloading_point) || 0;
      if (unloadingPoint > 0) {
        return unloadingPoint * pricePerTon;
      }
    }
    const loadingPoint =
      Number(this.tripData.workOrderOtherDetails?.loading_point) || 0;
    return loadingPoint * pricePerTon;
  }

  private getLatestEntries(data: any[]): any[] {
    const latestEntries = new Map<string, any>();

    data.forEach((item) => {
      const existing = latestEntries.get(item.name);
      if (!existing || new Date(item.date) > new Date(existing.date)) {
        latestEntries.set(item.name, item);
      }
    });

    return Array.from(latestEntries.values());
  }

  close() {
    this.matdialogref.close();
  }

  openCancelConfirmation(trip: any): void {
    this.matDialogRefCancelTrip = this.dialog.open(CorporateCancelTripComponent, {
      data: trip,
      autoFocus: false
    });

    this.matDialogRefCancelTrip.afterClosed().subscribe((res: any) => {
      if (res === 'refresh') {
      }
    });
  }

  consignment(item: any) {
    window.open(item.consignment_details.consignment_url, "_blank");
  }
  help() {
    this.close();
    this.router.navigateByUrl("/?target=support");
  }
}
